export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-exchange/kraken-ac0edb25db75a675089d09110040923a.png";